// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"510":"718fd644","565":"801c77e9","585":"07dd25f3","591":"454177fb","779":"c8b0aa38","825":"059900c6","861":"6b62a6c0","962":"15788bb2"}[chunkId] + ".chunk.js";
};